<template>
   <div class="sa-main">
       
      <div class="nuxt-loading-indicator" style="position:fixed;top:0;right:0;left:0;pointer-events:none;width:0%;height:5px;opacity:0;background:repeating-linear-gradient(to right,#00dc82 0%,#34cdfe 50%,#0047e1 100%);background-size:Infinity% auto;transition:width 0.1s, height 0.4s, opacity 0.4s;z-index:999999;"></div>
      
      <div data-v-ba2790b9>
         <div class="el-row main-preview panel-block" style="" data-v-ba2790b9>
            
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style=""
               data-v-ba2790b9>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18"
               style="" data-v-ba2790b9>
               <div class="sa-name" data-v-ba2790b9>真机展示 </div>
			   <!-- swiperbox -->
			   <div class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-24 el-col-lg-24 el-col-xl-24" style=""
			      data-v-ba2790b9=""><!--[-->
			      <div data-v-ba2790b9="" class="preview-content sa-flex sa-row-center">
			         <div data-v-ba2790b9="" class="el-scrollbar">
			            <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default">
			               <div class="el-scrollbar__view" style="">
			                  <div data-v-ba2790b9="" class="sa-shadow-wrap sa-flex">
			                     <div data-v-ba2790b9="" class="sa-button " :class="[previewindex == 0 && 'is-active']" @click="previewindex = 0">白色版</div>
			                     <div data-v-ba2790b9="" class="sa-button " :class="[previewindex == 1 && 'is-active']" @click="previewindex = 1">黑色版</div>
			                     <div data-v-ba2790b9="" class="sa-button " :class="[previewindex == 2 && 'is-active']" @click="previewindex = 2">管理端</div>
			                  </div>
			               </div>
			            </div>
			            <div class="el-scrollbar__bar is-horizontal" style="display: none;">
			               <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
			            </div>
			            <div class="el-scrollbar__bar is-vertical" style="display: none;">
			               <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
			            </div>
			         </div>
			      </div>
			   
			      <!-- <div data-v-ba2790b9="" class="swiper swiper-initialized swiper-horizontal" id="swiperMobile" v-if="previewindex == 0">
			         <div class="swiper-wrapper" id="swiper-wrapper1" aria-live="polite"
			         :style="{transform}">
			            <div data-v-ba2790b9="" class="swiper-slide" :aria-label="`${index} / ${preview[previewindex].items.length}`"
			               v-for="(item,index) in preview[previewindex].items" :key="index">
			               <img data-v-ba2790b9="" lazy="loaded" :src="item">
			            </div>
			         </div>
			         <div class="swiper-button-prev " :class="[swiperindex == 0 && 'swiper-button-disabled']" tabindex="-1" role="button" aria-label="Previous slide"
			            aria-controls="swiper-wrapper-56cab2fe3dee2b3f" aria-disabled="true" @click="prevswiper">
			         </div>
			         <div class="swiper-button-next" :class="[!shownext && 'swiper-button-disabled']" tabindex="0" role="button" aria-label="Next slide"
			            aria-controls="swiper-wrapper-56cab2fe3dee2b3f" aria-disabled="false" @click="nextswiper">
			         </div>
			         <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
			      </div>
			   
			      <div data-v-ba2790b9="" class="swiper swiper-initialized swiper-horizontal is-admin" id="swiperPc" v-if="previewindex == 1">
			         <div class="swiper-wrapper" id="swiper-wrapper2" aria-live="polite"
			            :style="{transform:transform1}">
			            <div data-v-ba2790b9="" class="swiper-slide" :aria-label="`${index} / ${preview[previewindex].items.length}`"
			               v-for="(item,index) in preview[previewindex].items" :key="index">
			               <img data-v-ba2790b9="" lazy="loaded" :src="item">
			            </div>
			         </div>
			         <div class="swiper-button-prev " :class="[swiperindex == 0 && 'swiper-button-disabled']" tabindex="-1" role="button" aria-label="Previous slide"
			            aria-controls="swiper-wrapper-56cab2fe3dee2b3f" aria-disabled="true" @click="prevswiper">
			         </div>
			         <div class="swiper-button-next" :class="[!shownext && 'swiper-button-disabled']" tabindex="0" role="button" aria-label="Next slide"
			            aria-controls="swiper-wrapper-56cab2fe3dee2b3f" aria-disabled="false" @click="nextswiper">
			         </div>
			         <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
			      </div> -->
			      
               <div class="swiperbox">
                  <div class="swiper" id="swiper">
                     <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in preview[previewindex].items" :key="index"
                           @click="previerimg(index,item)">
                           <img :src="item"/>
                        </div>
                     </div>
                     <!-- 如果需要分页器 -->
                     <div class="swiper-pagination"></div>
                     
                     
                     
                     <!-- 如果需要滚动条 -->
                     <div class="swiper-scrollbar"></div>
                  </div>
                  <!-- 如果需要导航按钮 -->
                  <div class="swiper-button-prev" @click="prev"></div>
                  <div class="swiper-button-next" @click="next"></div>
               </div>
			   </div>
            </div>

            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-ba2790b9></div>
            
            
         </div>
         <div data-v-ba2790b9 data-v-5607c557>
            <div class="el-row main-demo panel-block" style="" data-v-5607c557>
               <div class="el-col el-col-24 el-col-sm-2 el-col-lg-3" style="" data-v-5607c557></div>
               <div class="el-col el-col-24 el-col-sm-20 el-col-lg-18" style="" data-v-5607c557>
                  
                  <div class="sa-name" data-v-5607c557>系统演示</div>
                  <div class="sa-flex sa-row-center" data-v-5607c557>
                     <div class="demo-content sa-shadow-wrap sa-flex sa-flex-wrap sa-row-center"
                        data-v-5607c557>

                        <!-- 循环演示按钮 -->
                        <div class="sa-button demo-btn " :class="[index == value && 'is-active']"
                           v-for="(item,value) in list" :key="value" @click="index = value">
                           {{item.label}}
                        </div>

                     </div>
                  </div>
                  <div class="demo-content sa-flex sa-row-center" data-v-5607c557>
                     <div class="demo-block sa-block" data-v-5607c557>
                        <div class="shadow-1" data-v-5607c557></div>
                        <div class="shadow-2" data-v-5607c557></div>
                        <div class="shadow-3" data-v-5607c557></div>
                        <div class="mask sa-flex" data-v-5607c557>
                           <img class="qrcode" :src="list[index].qrcode"
                              data-v-5607c557>
                           <div class="right" data-v-5607c557>
                              <div class="title sa-flex" data-v-5607c557>
                                 <i :class="'iconfont icon-'+list[index].value" data-v-5607c557></i>
                                 <div data-v-5607c557>{{list[index].label}}体验平台</div>
                              </div>
                              <div class="item sa-flex" data-v-5607c557 v-if="list[index].url">
                                 <div class="item-label" data-v-5607c557>演示链接：</div>
                                 <div class="item-content url" data-v-5607c557>
                                    <a :href="list[index].url">{{list[index].url}}</a>
                                 </div>
                              </div>
                              <div class="item sa-flex" data-v-5607c557 v-if="list[index].downloadUrl">
                                 <div class="item-label" data-v-5607c557>下载地址：</div>
                                 <div class="item-content url" data-v-5607c557>
                                    <a :href="list[index].downloadUrl">{{list[index].downloadUrl}}</a>
                                 </div>
                              </div>
                              <div class="item sa-flex" data-v-5607c557 v-if="list[index].appStore">
                                 <div class="item-label" data-v-5607c557>AppStore：</div>
                                 <div class="item-content url" data-v-5607c557>
                                    <a :href="list[index].appStore">{{list[index].appStore}}</a>
                                 </div>
                              </div>
                              
                              <div class="item sa-flex" data-v-5607c557>
                                 <div class="item-label" data-v-5607c557>演示账号：</div>
                                 <div class="item-content" data-v-5607c557>{{list[index].name}}</div>
                              </div>
                              <div class="item sa-flex" data-v-5607c557>
                                 <div class="item-label" data-v-5607c557>演示密码：</div>
                                 <div class="item-content" data-v-5607c557>{{list[index].password}}</div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="el-col el-col-24 el-col-sm-2 el-col-lg-3" style="" data-v-5607c557></div>
            </div>
         </div>
      </div>
      <div class="popup" @click="showpreview = false">
         <div class="imgbox" :style="{wdith:imgwidth+'px',height:imgheight+'px'}">
            <img :width="imgwidth+'px'" :height="imgheight+'px'" :src="previewimg" alt="">
         </div>
      </div>     
   </div>
</template>
<script>
   import Swiper from 'swiper'
   export default {
      name: 'preview',
      data(){
         return {
            imgwidth: '',
            imgheight:'',
            showpreview:false,
            previewimg:'',
            mySwiper:null,
            preview:[{
               label: "白色版",
               value: "mobile",
               items: [
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/1.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/2.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/3.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/4.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/5.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/6.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/7.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/8.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/9.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/10.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/11.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/12.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/13.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/14.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/15.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/16.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/17.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/18.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/19.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/bspeiwan/20.png',
]
            },{
               label: "黑色版",
               value: "mobile",
               items: [
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/1.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/2.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/3.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/4.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/5.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/6.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/7.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/8.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/9.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/10.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/11.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/12.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/13.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/14.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/15.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/16.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/17.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/18.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/19.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/20.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/21.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/22.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/23.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/24.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/25.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/26.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/27.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/28.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/29.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/30.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/31.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/32.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/33.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/34.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/35.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/36.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/37.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/38.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/yanshisj/39.png',
                ]
            }, {
               label: "管理端",
               value: "pc",
               items: [
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/1.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/2.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/3.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/4.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/5.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/6.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/7.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/8.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/9.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/10.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/11.png',
                  'https://huolieniaopeiwan.oss-cn-beijing.aliyuncs.com/%E9%83%91%E5%B7%9E%E5%85%AC%E5%8F%B8/guanli/12.png',
                ]
            }],
            previewindex: 0,
            swiperindex:0,
            list: [{
                label: "管理端",
                value: "Admin",
																
												
                qrcode: require('../assets/image/yanshi/houtai.png'),
                url: "https://peiwanblogs.huolieniaowangluo.com/admin/",
                name: "test",
                password: "123456"
            }, {
                label: "H5",
                value: "H5",
                qrcode: require('../assets/image/yanshi/h5.png'),
                url: "https://peiwanblogs.huolieniaowangluo.com/h5/",
                name: "验证码",
                password: "a123456"
            }, {
                label: "微信小程序",
                value: "WechatMiniProgram",
                qrcode: require('../assets/image/yanshi/h5.png'),
                name: "验证码",
                password: "123456"
            }, {
                label: "Android",
                value: "Android",
                qrcode: require('../assets/image/yanshi/app.png'),
                downloadUrl: "https://www.ekaifa.cc/cw5knj",
                name: "验证码",
                password: "a123456"
            }, {
                label: "iOS",
                value: "iOS",
                qrcode: require('../assets/image/yanshi/app.png'),
                appStore: "https://www.ekaifa.cc/cw5knj",
                name: "验证码",
                password: "a123456"
            }],
            index: 0,
            transform: 'translate3d(0px, 0px, 0px)',
            transform1: 'translate3d(0px, 0px, 0px)',
            shownext:true
         }
      },
      
   watch: {
      showpreview(newval, oldval) {
         var imgbox = document.querySelector(".imgbox");
         var popup = document.querySelector(".popup");
         if (newval) {
            console.log(newval);
            popup.style.display = "block";
            setTimeout(() => {
               popup.style.opacity = "1";
            }, 16);
            
         } else {
            popup.style.opacity = "0";
            setTimeout(() => {
               popup.style.display = "none";
            }, 300);
         }
      },
         previewindex(newval, oldval) {
            let width = document.body.clientWidth;
            if (newval == 0 || newval == 1) {
               if (width > 1200) {
                  this.mySwiper.params.slidesPerView = 4;
               } else if (width <= 1200 && width > 950) {
                  this.mySwiper.params.slidesPerView = 3;
               } else if (width <= 950 && width > 600) {
                  this.mySwiper.params.slidesPerView = 2;
               } else if (width <= 600) {
                  this.mySwiper.params.slidesPerView = 1;
               }
            } else {
               if (width > 900) {
                  this.mySwiper.params.slidesPerView = 2;
               }else{
                  this.mySwiper.params.slidesPerView = 1;
               }
            }
            
         }
      },
      methods:{
         // 上一个
         prevswiper() {
            if (this.swiperindex>0) {
               this.swiperindex -= 1;
            };
         },
         // 下一个
         nextswiper() {
            if (this.swiperindex < this.preview[this.previewindex].items.length - 1) {
               this.swiperindex += 1;
            };
         },

         next() {
            this.mySwiper.slideNext()
         },
         prev() {
            this.mySwiper.slidePrev()
         },
         previerimg(index, item) {
            console.log(12121);
            let width = document.documentElement.clientWidth;
            let height = document.documentElement.clientHeight;
            var img = new Image();
            img.src = item;
            
            let bi = img.width / img.height;
            //90%高
            if ((0.9*height)*bi < width) {
               this.imgwidth = 0.9 * height * bi;
               this.imgheight = 0.9*height
            } else {
               this.imgwidth = 0.6 * width;
               this.height = 0.9 * height / bi
            }
            this.previewimg = item;
            this.showpreview = true
         }
   },
   beforeDestroy() {
      window.removeEventListener('resize',()=>{})
   },
   mounted() {
      window.scrollTo({top: 0, behavior:'smooth'});
      window.addEventListener('resize', (e) => {
         // console.log(this.previewindex);
            let width = document.body.clientWidth;
            if (this.previewindex == 0 || this.previewindex == 1) {
               if (width > 1200) {
                  this.mySwiper.params.slidesPerView = 4;
               } else if (width <= 1200 && width > 950) {
                  this.mySwiper.params.slidesPerView = 3;
               } else if (width <= 950 && width > 600) {
                  this.mySwiper.params.slidesPerView = 2;
               } else if (width <= 600) {
                  this.mySwiper.params.slidesPerView = 1;
               } 
            } else {
               if (width > 900) {
                  this.mySwiper.params.slidesPerView = 2;
               }else{
                  this.mySwiper.params.slidesPerView = 1;
               }
            } 
         })
      let width = document.body.clientWidth;
      let slidesPerView = 4;
         if (this.previewindex == 0 || this.previewindex == 1) {
            if (width > 1200) {
               slidesPerView = 4;
            } else if (width <= 1200 && width > 950) {
               slidesPerView = 3;
            } else if (width <= 950 && width > 600) {
               slidesPerView = 2;
            } else if (width <= 600) {
               slidesPerView = 1;
            }
         } 
         this.mySwiper = new Swiper ('#swiper', {
            direction: 'horizontal', // 垂直切换选项
            loop: false, // 循环模式选项
            grabCursor: true,
            slidesPerView,  
            spaceBetween:30,
            // 如果需要分页器
            pagination: {
               el: '.swiper-pagination',
            },
            
            // 如果需要前进后退按钮
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev',
            },
            
            // 如果需要滚动条
            scrollbar: {
               el: '.swiper-scrollbar',
            },
         })
      }
     
   };
</script>
<style scoped>
   
   
   @import '../assets/css/index.css';
   @import '../assets/css/preview.css';
   .swiperbox{
      position: relative;
   }
   .swiper-button-prev{
      position: absolute;
      left: -.4rem;
      top: 50%;
      /* transform: translateY(-50%); */
      width: 0.5rem;
      height: 0.5rem;
      background-color: #806af6;
      border-radius: 0.1rem;
      color: #fff;
   }
   .swiper-button-prev:hover{
      background-color: #b4a7ff;
   }
   .swiper-button-prev:after{
      font-size: 0.3rem !important;
   }
   .swiper-button-next{
      position: absolute;
      right: -0.4rem;
      top: 50%;
      /* transform: translateY(-50%); */
      width: 0.5rem;
      height: 0.5rem;
      background-color: #806af6;
      border-radius: 0.1rem;
      color: #fff;
      
   }
   .swiper-button-next:hover{
      background-color: #b4a7ff;
   }
   .swiper-button-next:after{
      font-size: 0.3rem !important;
   }
   @media (max-width: 512px) and (min-width: 320px) {
      .swiper-button-next {
         width: 40px;
         height: 40px;
         border-radius: 8px;
      }
      .swiper-button-prev {
         width: 40px;
         height: 40px;
         border-radius: 8px;
      }
   }
   @media (min-width: 900px) {
      .swiper-button-next {
         right: -0.7rem;
      }
      .swiper-button-prev {
         left: -0.7rem;
      }
   }
   @media (max-width: 800px) {
      .swiper-button-next {
         right: -0.2rem;
      }
      .swiper-button-prev {
         left: -0.2rem;
      }
   }
   @media  (max-width: 320px) {
      .swiper-button-next {
         width: 25px;
         height: 25px;
         border-radius: 3px;
      }
      .swiper-button-prev {
         width: 25px;
         height: 25px;
         border-radius: 3px;
      }
   }
   .popup{
      position: fixed;
      transition: all 0.3s ease-in-out;
      display: none;
      top:0;
      opacity: 0;
      left:0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.5);
      z-index: 999;
   }
   .popup .imgbox{
      transition: all 0.11s ease-in-out;
      position: fixed;
      top:50%;
      left:50%;
      transform: translate(-50% ,-50%);
   }
   .swiper{
      padding:20px 30px;
      width: 100%;
      /* height: 500px; */
   }
   .swiper-wrapper {
      position: relative;
      width: 100%;
      
   }
   .swiper-wrapper .swiper-slide {
      width: 50px;
      height: 100%;
      padding: 10px;
      border-radius: 20px;
      background-color: #eee9ff;
   }
   .swiper-wrapper .swiper-slide img{
      width: 100%;
      height: 100%;
      border-radius: 15px;
   }
   @media (max-width: 1000px) {
      .swiper-wrapper .swiper-slide {
         padding: 0.08rem !important;
         border-radius: 0.08rem;
      }
      .swiper-wrapper .swiper-slide img{
         border-radius: 0.08rem;
      }
   }
   /* .main-preview[data-v-ba2790b9] .swiper-button-next,.main-preview[data-v-ba2790b9] .swiper-button-prev {
      background: var(--el-color-primary);
      border-radius: .08rem;
      color: #fff;
      height: .4rem;
      margin-top: -.4rem!important;
      width: .4rem;
   } */
   
</style>